import { Component, inject, OnInit, Optional, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProviderService } from '../provider.service';
import { Provider } from '../../models/provider.model';
import { finalize } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { checkRut } from '../../utils/client-utils';
import { AdminService } from '../../admin/services/admin.service';

@Component({
    selector: 'app-provider-form',
    templateUrl: './provider-form.component.html',
    styleUrl: './provider-form.component.scss',
    standalone: false
})
export class ProviderFormComponent implements OnInit {
  private readonly fb = inject(FormBuilder);

  private readonly providerService = inject(ProviderService);

  public creating = signal(false);

  private readonly companyService = inject(AdminService);

  private country = this.companyService.local$.getValue().country;

  public form: FormGroup = this.fb.group({
    name: this.fb.control('', { validators: Validators.required }),
    email: this.fb.control('', { validators: [Validators.required, Validators.email] }),
    rut: this.fb.control('', { validators: Validators.required }),
    address: this.fb.control('', { validators: Validators.required }),
    phone: this.fb.control('', { validators: Validators.required }),
  });


  constructor(
    @Optional() private matDialogRef: MatDialogRef<ProviderFormComponent>,
  ) { }

  ngOnInit(): void {
    if (this.country.code === 'cl') {
      this.form.get('rut').setValidators(checkRut);
    }
  }

  createProvider() {
    this.creating.set(true);
    this.providerService.create(this.form.value as Provider).pipe(
      finalize(() => this.creating.set(false)),
    ).subscribe((response) => {
      this.matDialogRef.close(response.body);
    });
  }

}
